import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { GetProductivityParametersInputDto, ProductivityParameterCreateDto, ProductivityParameterDto, ProductivityParameterExcelDownloadDto, ProductivityParameterUpdateDto } from '../dtos/productivity-parameter/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class ProductivityParameterService {
  apiName = 'WoodSupply';
  

  create = (input: ProductivityParameterCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ProductivityParameterDto>({
      method: 'POST',
      url: '/api/woodSupply/productivityParameters',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/woodSupply/productivityParameters/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/woodSupply/productivityParameters',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ProductivityParameterDto>({
      method: 'GET',
      url: `/api/woodSupply/productivityParameters/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/woodSupply/productivityParameters/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetProductivityParametersInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<ProductivityParameterDto>>({
      method: 'GET',
      url: '/api/woodSupply/productivityParameters',
      params: { productivityParameterGroupId: input.productivityParameterGroupId, productivityParameterGroupName: input.productivityParameterGroupName, name: input.name, value: input.value, valueFrom: input.valueFrom, valueTo: input.valueTo, productivityPercentage: input.productivityPercentage, productivityPercentageFrom: input.productivityPercentageFrom, productivityPercentageTo: input.productivityPercentageTo, code: input.code, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: ProductivityParameterExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/woodSupply/productivityParameters/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, productivityParameterGroupId: input.productivityParameterGroupId, productivityParameterGroupName: input.productivityParameterGroupName, name: input.name, value: input.value, valueFrom: input.valueFrom, valueTo: input.valueTo, productivityPercentage: input.productivityPercentage, productivityPercentageFrom: input.productivityPercentageFrom, productivityPercentageTo: input.productivityPercentageTo, code: input.code, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ProductivityParameterDto[]>({
      method: 'GET',
      url: '/api/woodSupply/productivityParameters/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: ProductivityParameterUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ProductivityParameterDto>({
      method: 'PUT',
      url: `/api/woodSupply/productivityParameters/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
